import React from 'react';
import ReactDOM from 'react-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import "bootstrap/dist/css/bootstrap.min.css";
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ThemeProvider } from './Contexts/themeProvider'; 
import { LanguageProvider } from './Contexts/LanguageContext'; 

ReactDOM.render(
  <React.StrictMode>
      <ThemeProvider>
        <LanguageProvider>
          <App />
          <ToastContainer position="top-right" autoClose={3000} />
        </LanguageProvider>
      </ThemeProvider>
  </React.StrictMode>,
  document.getElementById('root')
);
reportWebVitals();
